export default []

    // ... other map styles